// Webinar landing page config — edit these values per webinar, no other code
// changes needed. Used by WebinarPage.tsx and WebinarThanksPage.tsx.

export const WEBINAR = {
  // Identifies the webinar in webinar_registrations.webinar_slug
  slug: 'build-ai-2026',

  title: 'Stop tutorial hell. Build AI in 2026.',
  subtitle:
    'A live technical build-session for developers, career switchers and students with programming knowledge. ' +
    'Watch a real AI application come to life — and learn how to build one yourself.',

  dateDisplay: 'Tuesday, July 28 · 7:00 PM IST',

  entryPrice: '₹9',

  // TODO(Francis): paste the Razorpay Payment Link URL (Dashboard → Payment Links →
  // create a fixed ₹9 link; set its callback/redirect URL to
  // https://cubemate.ai/webinar/thanks). Empty string = skip payment and go
  // straight to the thanks page (useful for testing).
  razorpayLink: 'https://rzp.io/rzp/0APpvcvq',

  // TODO(Francis): paste the WhatsApp group invite link
  whatsappLink: 'https://chat.whatsapp.com/KwNGlmsVZj31AaomOfFKj3',

  // Google Ads conversion label for "cubemate-webinar" registration
  // (created 2026-07-12). Empty string = Google conversion not fired
  // (Meta pixel Lead still fires regardless).
  googleAdsConversion: 'AW-18013772297/rjm_COuc8M4cEIm00Y1D',
};
